// extracted by mini-css-extract-plugin
export default {"container":"Join_container__Oen8p","title":"Join_title__phxVS","p":"Join_p__OZNOM"};